import OMovieDescriptionBlock from './o-movie-description-block.vue';

export default OMovieDescriptionBlock;